<template>
  <div class="container">
    <div class="jl-tips-recommend" @click="toDetail(recData)" v-if="isShowRecommend">
      <div class="jl-tips-recommend-img">
        <img :src="recData.imgUrl" alt="推荐位信息图片" />
      </div>
      <div class="jl-tips-recommend-content">
        <p>{{ recData.title }}</p>
        <p>
          <i class="jl-icon-icon_shizhongxia"></i>
          发布时间 ： {{ recData.createDate }}
        </p>

        <p>{{ recData.intro }}</p>
      </div>
    </div>
    <div class="jl-tips-list">
      <div class="jl-tips-list-wraper clearfix">
        <div v-loading="isloading" class="jl-loading-box">
          <div class="jl-com-nodata-tips" v-if="nodata">
            <div class="jl-com-nodata-box">
              <i class="jl-icon-wushuju"></i>
              <p class="text">暂无数据</p>
            </div>
          </div>
          <div
            class="jl-tips-list-item"
            v-for="(item, index) in tipsData"
            :key="'know-'+index"
            @click="toDetail(item)"
          >
            <div class="box">
              <div class="box-img">
                <img :src="item.imgUrl" />
              </div>
              <div class="jl-tips-list-item-intro">
                <div class="box-tips">
                  <p>{{ item.title }}</p>
                  <p>{{ item.intro }}</p>

                  <p class="box-tips-time">
                    <i class="jl-icon-icon_shizhongxia"></i>
                    发布时间 ： {{ item.createDate }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="jl-list-pagination" v-if="tipsData.length > 0">
        <div class="page-box">
          <v-pagination
            :total="total"
            :display="display"
            :currentPage="current"
            @pagechange="pagechange"
          ></v-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getKnowledgeList } from "../../api/knowledge";
import Pagination from "../../components/Pagination";
export default {
  name: "knowledgeIndex",
  components: {
    "v-pagination": Pagination
  },
  data() {
    return {
      recData: {},
      tipsData: [],
      total: 1,
      display: 9,
      current: 1,
      listScrollTop: 0,
      isShowRecommend: false,
      isloading: true,
      nodata: false
    };
  },
  created() {
    this.initData();
  },
  mounted() {
    this.$nextTick(() => {
      this.listScrollTop = this.$publicMethods.getPoint(
        document.getElementsByClassName("jl-tips-list")[0]
      ).t;
    });
  },
  methods: {
    pagechange(idx) {
      this.current = idx;
      getKnowledgeList(this);
      window.scrollTo(0, this.listScrollTop);
    },
    initData() {
      getKnowledgeList(this);
    },
    toDetail(item) {
      this.$router.push({ name: "knowledgeDetail", params: { id: item.id } });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-tips-recommend {
  max-width: 1200px;
  margin: 40px auto;
  cursor: pointer;

  .jl-tips-recommend-img {
    position: relative;
    height: 405px;
    width: 540px;
    display: inline-block;
    vertical-align: top;
    text-align: center;
    overflow: hidden;
    &::after {
      /* content: "";
      display: inline-block;
      vertical-align: middle;
      width: 0;
      height: 100%; */
    }
    img {
      /* display: inline-block;
      vertical-align: middle;
      max-width: 100%;
      max-height: 100%; */
      display: block;
      width: 100%;
      transition: all 0.3s;
    }
  }
  .jl-tips-recommend-content {
    height: 405px;
    width: 660px;
    display: inline-block;
    vertical-align: top;
    padding: 40px;
    box-shadow: 0 0 9px rgba($color: #3c3c3c, $alpha: 0.15);
    font-weight: 500;
    font-size: 0;
    text-align: left;

    p:first-child {
      line-height: 24px;
      text-align: left;
      color: #333;
      font-weight: 500;
      font-size: 24px;
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 17px;
    }
    p:nth-child(2) {
      line-height: 14px;
      font-size: 14px;
      color: #666;
      margin-bottom: 40px;

      i {
        margin-right: 10px;
      }
    }
    p:last-child {
      color: #666;
      font-size: 16px;
      overflow: hidden;
      text-align: left;
      line-height: 32px;
      max-height: 192px;
      margin-top: 32px;
    }
  }
}
.jl-tips-list {
  max-width: 1200px;
  margin: 0 auto;
  padding-bottom: 120px;
  text-align: left;
  font-weight: 500;
  margin-top: 40px;
  .jl-tips-list-wraper {
    margin-left: -15px;
    margin-right: -15px;
  }
  .jl-tips-list-item {
    float: left;
    width: 33.33%;
    padding: 0 15px 30px;
    cursor: pointer;
    .box {
      box-shadow: 5px 5px 15px rgba($color: #3c3c3c, $alpha: 0.2);
      background: #fff;
      overflow: hidden;
    }
    .box-img {
      position: relative;
      // height: 285px;
      overflow: hidden;
      text-align: center;
      &::after {
        /* content: "";
        display: inline-block;
        vertical-align: middle;
        width: 0;
        height: 100%; */
      }
      img {
        /* display: inline-block;
        vertical-align: middle;
        max-width: 100%;
        max-height: 100%; */
        display: block;
        width: 100%;
        transition: all 0.3s;
      }
    }
    .jl-tips-list-item-intro {
      padding: 25px 20px 0 20px;
      height: 191px;
      border: 1px solid #eee;

      .box-tips {
        position: relative;
        height: 100%;
      }
      .box-tips-time {
        position: absolute;
        bottom: 27px;
        left: 0;
        width: 100%;
        padding-top: 20px;
        border-top: 1px solid #e1e1e1;
      }
      p {
        color: #666;
        font-size: 14px;
        line-height: 24px;
        max-height: 48px;
        overflow: hidden;

        i {
          margin-right: 10px;
        }
      }
      p:first-child {
        color: #333;
        font-size: 18px;
        line-height: 18px;
        white-space: nowrap;
        text-overflow: ellipsis;
        margin-bottom: 15px;
      }
    }
  }
}

.jl-list-pagination {
  text-align: center;
  .page-box {
    display: inline-block;
  }
}

@media screen and (min-width: 1200px) {
  .jl-tips-recommend .jl-tips-recommend-img:hover img {
    transform: scale(1.1);
  }
  .jl-tips-list .jl-tips-list-item:hover {
    .box {
      box-shadow: 5px 5px 15px rgba($color: #3c3c3c, $alpha: 0.5);
    }
    .box-img img {
      transform: scale(1.1);
    }
  }
}
</style>

